<form (submit)="sign()" novalidate>
    @if (!selectedToken) {
        <ap-browser-selector (tokenSelected)="selectToken($event)" [implicitSigning]="implicitSigning()" [tokens]="tokens">
        </ap-browser-selector>
    }
    @if (selectedToken) {
        @if (anonymous()) {
            <h2 data-bb="pincodeTitle">
                {{ 'browser.user.title' | apContent: { username: selectedToken.username } }}
            </h2>
        }
        <ap-browser-pincode
            [pincodeControl]="signResponse"
            [cancelText]="cancelText()"
            [submitText]="submitText()"
            [canSign]="canSign"
            [showLostCredentials]="showLostCredentials()"
            (cancel)="cancel()"
            (lostCredentials)="onLostCredentials()"
            (submitted)="sign()"
        >
        </ap-browser-pincode>
    }
</form>
